// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_footer__EwVYi{
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: 0;
    height: 72px;
    width: 100%;
    color: #1F363D;
    background-color: #FFFFFF;
    font-size: 14px;
    border-top: 1px solid #70A9A11A;
    border-radius: 30px 30px 0 0;
}
@media(max-width: 660px){
    .Footer_footer__EwVYi{
        display: block;
        height: 32px;
        padding: 19px 0 21px 0;
        text-align: center;
    }
}
@media(max-width: 540px){
    .Footer_footer__EwVYi{
        font-size: 12px;
    }
}
.Footer_links__q2x7d{
    margin-left: 5px;
}
@media(max-width: 660px){
    .Footer_links__q2x7d{
        margin-top: 2px;
    }
}
.Footer_link__MsGIJ{
    margin-left: 5px;
    margin-right: 5px;
    color: #40798C;
    font-size: 12px;
    text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Footer.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,+BAA+B;IAC/B,4BAA4B;AAChC;AACA;IACI;QACI,cAAc;QACd,YAAY;QACZ,sBAAsB;QACtB,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,eAAe;IACnB;AACJ;AACA;IACI,gBAAgB;AACpB;AACA;IACI;QACI,eAAe;IACnB;AACJ;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,qBAAqB;AACzB","sourcesContent":[".footer{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    bottom: 0;\n    height: 72px;\n    width: 100%;\n    color: #1F363D;\n    background-color: #FFFFFF;\n    font-size: 14px;\n    border-top: 1px solid #70A9A11A;\n    border-radius: 30px 30px 0 0;\n}\n@media(max-width: 660px){\n    .footer{\n        display: block;\n        height: 32px;\n        padding: 19px 0 21px 0;\n        text-align: center;\n    }\n}\n@media(max-width: 540px){\n    .footer{\n        font-size: 12px;\n    }\n}\n.links{\n    margin-left: 5px;\n}\n@media(max-width: 660px){\n    .links{\n        margin-top: 2px;\n    }\n}\n.link{\n    margin-left: 5px;\n    margin-right: 5px;\n    color: #40798C;\n    font-size: 12px;\n    text-decoration: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer_footer__EwVYi`,
	"links": `Footer_links__q2x7d`,
	"link": `Footer_link__MsGIJ`
};
export default ___CSS_LOADER_EXPORT___;
